module.exports = __webpack_public_path__ + "img/screen_empty_activityfeed@2x.7d15eb17.png";